import {
  wellbeingMaterialCategoriesSearchSchema,
  wellbeingMaterialCategoriesViewColumns,
  mapWellbeingMaterialCategoriesViewQuery,
} from "./WellbeingMaterialCategoriesView.default";
import ManagedGridView from "../../controls/ManagedGridView";
import { SearchQuery } from "../../code/search-query/search-query";
import { getWellbeingMaterialCategories } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface WellbeingMaterialCategoriesViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function WellbeingMaterialCategoriesView(
  props: WellbeingMaterialCategoriesViewProps,
) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={wellbeingMaterialCategoriesViewColumns}
      schema={wellbeingMaterialCategoriesSearchSchema}
      mapQuery={mapWellbeingMaterialCategoriesViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getWellbeingMaterialCategories, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("WellbeingCornerCategories", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("WellbeingCornerCategories", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default WellbeingMaterialCategoriesView;
